import api from '../lib/api';
import type { ApiResponse } from '@maios/shared';

export interface UsageSummaryItem {
  featureKey: string;
  label: string;
  count: number;
}

export interface UsageSummaryResponse {
  period: { from: string; to: string };
  data: UsageSummaryItem[];
}

export interface UsageTrendsResponse {
  labels: string[];
  datasets: Record<string, number[]>;
}

export interface UsageHeatmapResponse {
  organizations: Array<{ id: string; name: string }>;
  featureKeys: string[];
  featureLabels: Record<string, string>;
  matrix: number[][];
}

export async function getUsageSummary(days: number): Promise<UsageSummaryResponse> {
  const res = await api.get<ApiResponse<UsageSummaryResponse>>(`/admin/usage/summary?days=${days}`);
  return res.data.data!;
}

export async function getUsageTrends(days: number, featureKey?: string): Promise<UsageTrendsResponse> {
  const query = new URLSearchParams({ days: String(days) });
  if (featureKey) query.set('featureKey', featureKey);
  const res = await api.get<ApiResponse<UsageTrendsResponse>>(`/admin/usage/trends?${query}`);
  return res.data.data!;
}

export async function getUsageHeatmap(days: number, limit?: number): Promise<UsageHeatmapResponse> {
  const query = new URLSearchParams({ days: String(days) });
  if (limit) query.set('limit', String(limit));
  const res = await api.get<ApiResponse<UsageHeatmapResponse>>(`/admin/usage/heatmap?${query}`);
  return res.data.data!;
}
